<div *ngIf="show" [ngClass]="{ preloader: global }">
	<div class="text-center">
		<span class="inline-block">
			<mat-spinner [diameter]="diameter"></mat-spinner>
		</span>
	</div>
</div>
